/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_AltInputs */

const en_gc_search_guides_gridcraft_online_sections_0_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gridcraft.me launch screen with a Launch GridCraft button and four starting-point choices`)
};

const zh_gc_search_guides_gridcraft_online_sections_0_figure_alt = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gridcraft.me 启动界面，包含 Launch GridCraft 按钮和四个起点选项`)
};

/**
* | output |
* | --- |
* | "Gridcraft.me launch screen with a Launch GridCraft button and four starting-point choices" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_AltInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_0_figure_alt = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_AltInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_0_Figure_AltInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_0_figure_alt(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_0_figure_alt(inputs)
});
export { gc_search_guides_gridcraft_online_sections_0_figure_alt as "gc.search_guides.gridcraft_online.sections.0.figure.alt" }